import api from '@/api/'

export const strategyCommand = {
  edit(data) {
    this.$router.push(`/interview/edit/${data.id}`)
  },
  check(data, status) {
    const _this = this
    this.$confirm({
      content: `确定要${status === 2 ? '通过' : '拒绝'}吗？`,
      cancelText: '取消',
      okText: '确认',
      async onOk() {
        const res = await api.updateStateInterview({ id: data.id, status })
        if (_this.$validate(res)) {
          _this.$message.success('操作成功~')
          _this.getList()
        }
      }
    })
  },
  delete(data) {
    const _this = this
    this.$confirm({
      content: '确定要删除吗？',
      cancelText: '取消',
      okText: '确认',
      async onOk() {
        const res = await api.deleteInterview({ id: data.id })
        if (_this.$validate(res)) {
          _this.$message.success('删除成功~')
          _this.getList()
        }
      }
    })
  }
}
